import { FC, useState } from 'react';

import ChevronDown from '@/assets/icons/ChevronDown';
import { DefectGroupedByEenheid } from '@/domain/defecten/defectEenheid';
import { Defect } from '@/types/Defecten';

import LmmDefectListItem from '../LmmDefect/LmmDefectListItem';

import styles from './LmmVerwachtStellenSection.module.css';

type LmmVerwachtStellenSectionProps = {
  title: string;
  defecten: (Defect | DefectGroupedByEenheid)[];
  defaultOpen?: boolean;
  isVerwachtGereed?: boolean;
};

/** Collapsible list of eenheden with a count badge, e.g. 'Verwacht niet inzetbaar (3)'. */
const LmmVerwachtStellenSection: FC<LmmVerwachtStellenSectionProps> = ({
  title,
  defecten,
  isVerwachtGereed = false,
  defaultOpen = true,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={styles.section}>
      <button type='button' className={styles.sectionHeader} onClick={() => setOpen((current) => !current)}>
        <span className={styles.sectionHeaderLeft}>
          <span className={styles.sectionTitle}>{title}</span>
          <span className={styles.countBadge}>{defecten.length}</span>
        </span>
        <ChevronDown className={[styles.chevronIcon, open ? styles.chevronIconOpen : ''].join(' ')} />
      </button>
      {open && (
        <div className={styles.sectionContent}>
          {defecten.length === 0 && <div className={styles.empty}>Geen eenheden</div>}
          {defecten.map((defect) => (
            <LmmDefectListItem
              key={`defecten_${title}_${defect.eenheidNummer}`}
              isVerwachtGereed={isVerwachtGereed}
              defect={defect}
            />
          ))}
        </div>
      )}
    </div>
  );
};
export default LmmVerwachtStellenSection;
